const SITE_DOMAIN =
  process.env.NEXT_PUBLIC_SITE_DOMAIN || 'https://www.lume.com';

export function getSiteDomain() {
  return SITE_DOMAIN;
}
